import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import MobileSearchInput from './MobileSearchInput';
import { IoArrowUp } from 'react-icons/io5';

type props = {
    children: React.ReactNode;
    className?: string;
    showMobileSearch?: boolean; // New prop to control MobileSearchInput visibility
};

const PageLayout = ({ children, className, showMobileSearch = false }: props) => {
    const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        // Check if screen is mobile or tablet (less than 1024px)
        const checkScreenSize = () => {
            setIsMobileOrTablet(window.innerWidth < 1024);
        };

        // Handle scroll event
        const handleScroll = () => {
            const scrollY = window.scrollY;
            setShowScrollTop(scrollY > 300); // Show button after scrolling 300px
        };

        // Initial checks
        checkScreenSize();
        handleScroll();

        // Add event listeners
        window.addEventListener('resize', checkScreenSize);
        window.addEventListener('scroll', handleScroll);

        // Cleanup
        return () => {
            window.removeEventListener('resize', checkScreenSize);
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div className={cn('pb-28 bg-[rgb(239_247_255)]', className)}>
            {/* Only render MobileSearchInput on mobile/tablet and when showMobileSearch is true */}
            {isMobileOrTablet && showMobileSearch && (
                <div>
                    <MobileSearchInput />
                </div>
            )}
            {children}

            {/* Scroll to Top Button */}
            <button
                onClick={scrollToTop}
                className={cn(
                    'fixed right-4 bottom-20 md:bottom-8 p-2 rounded-full bg-white/80 backdrop-blur-sm shadow-md',
                    'text-gray-600 hover:text-primary-default transition-all duration-300',
                    'border border-gray-200 hover:border-primary-default/30',
                    'opacity-0 translate-y-4 pointer-events-none',
                    showScrollTop && 'opacity-100 translate-y-0 pointer-events-auto'
                )}
                aria-label="Scroll to top"
            >
                <IoArrowUp size={20} />
            </button>
        </div>
    );
};

export default PageLayout;